import { Container, Text, type TextStyleOptions } from 'pixi.js';

export interface TitleSceneConfig {
  canvasWidth: number;
  canvasHeight: number;
}

export interface TitleScene {
  container: Container;
  titleText: Text;
  promptText: Text;
  destroy(): void;
}

const TITLE_STYLE: TextStyleOptions = {
  fontFamily: 'monospace',
  fontSize: 56,
  fontWeight: 'bold',
  fill: 0x22ff22,
  letterSpacing: 4,
};

const PROMPT_STYLE: TextStyleOptions = {
  fontFamily: 'monospace',
  fontSize: 20,
  fontWeight: 'bold',
  fill: 0xffffff,
};

export function createTitleScene(
  parent: Container,
  config: TitleSceneConfig,
): TitleScene {
  const container = new Container();
  container.label = 'title-scene';
  parent.addChild(container);

  const cx = config.canvasWidth / 2;
  const cy = config.canvasHeight / 2;

  const titleText = new Text({ text: 'SPACE INVADERS', style: TITLE_STYLE });
  titleText.anchor.set(0.5, 0.5);
  titleText.x = cx;
  titleText.y = cy - 40;
  container.addChild(titleText);

  const promptText = new Text({
    text: 'PRESS SPACE TO START',
    style: PROMPT_STYLE,
  });
  promptText.anchor.set(0.5, 0.5);
  promptText.x = cx;
  promptText.y = cy + 60;
  container.addChild(promptText);

  return {
    container,
    titleText,
    promptText,
    destroy() {
      container.destroy({ children: true });
    },
  };
}
